import React from 'react';

import {
    AlertLightIcon,
    AssessmentLightIcon,
    DatasetsLightIcon,
    ExploitsLightIcon,
    McpLightIcon,
    VulnerabilityIntelligenceLightIcon
} from 'pages/Landings/components/Icons';
import MenuItem from 'pages/Landings/components/TopMenu/components/MenuItem';
import SubMenu from 'pages/Landings/components/TopMenu/components/SubMenu';
import SubMenuItem from 'pages/Landings/components/TopMenu/components/SubMenuItem';

interface Props {
    container?: () => HTMLElement;
}
export const Docs: React.FC<Props> = ({ container }) => {
    return (
        <>
            <MenuItem to="#products" title={'Products'} container={container} anchor={container}>
                <SubMenu>
                    <SubMenuItem
                        icon={<VulnerabilityIntelligenceLightIcon />}
                        href="https://docs.vulners.com/docs/products/intelligence"
                        title="Vulnerability Intelligence"
                        subtitle="Сontext enrichment"
                    />
                    <SubMenuItem
                        icon={<AssessmentLightIcon />}
                        href="https://docs.vulners.com/docs/products/assessment"
                        title="Assessment"
                        subtitle="Instant software assessment"
                    />
                    <SubMenuItem
                        icon={<DatasetsLightIcon />}
                        href="https://docs.vulners.com/docs/products/datasets"
                        title="Datasets"
                        subtitle="Unified datasets"
                    />
                    <SubMenuItem
                        icon={<AlertLightIcon />}
                        href="https://docs.vulners.com/docs/products/alerts"
                        title="Alert"
                        subtitle="Targeted vuln alerts"
                    />
                    <SubMenuItem
                        icon={<ExploitsLightIcon />}
                        href="https://docs.vulners.com/docs/products/exploits"
                        title="Exploits"
                        subtitle="Real-world exploit tracking"
                    />
                    <SubMenuItem
                        icon={<McpLightIcon />}
                        href="https://docs.vulners.com/docs/products/mcp"
                        title="MCP"
                        subtitle="Live AI vulnerability feed"
                    />
                </SubMenu>
            </MenuItem>
            <MenuItem
                href="https://docs.vulners.com/docs/reference/"
                title={'API'}
                container={container}
                anchor={container}
            />
            <MenuItem
                href="https://docs.vulners.com/docs/guides/"
                title={'Guides'}
                container={container}
                anchor={container}
            />
            <MenuItem to="/changelog" title={'Changelog'} container={container} anchor={container} />
        </>
    );
};
